export default "__VITE_ASSET__CKj0tB4A__"